export enum EReportingUrl {
  REPORTS = 'reports',
  RECIPIENTS = 'recipients',
  SCHEDULES = 'schedules',
  CANDIDATES = 'candidates',
  PET_CHARGING_INFO = 'pet-charging-info',
  EXPORT = 'export',
  SCHEDULE = 'schedule',
}
